import {useState, useEffect} from "react";
import {
  ApiResponseFromCMS,
  IClusterDataFromServer,
} from "../pages/Dashboard/Dashboard.type";

const useFetchDataTechClusterById = (
  apiUrl: string,
  apiKey: string,
  clusterId: string
) => {
  const [clusterData, setClusterData] =
    useState<ApiResponseFromCMS<IClusterDataFromServer> | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!clusterId) return;

    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const url = new URL(`${apiUrl}/${clusterId}`);
    url.searchParams.set("populate", "*");
    url.searchParams.set(
      "populate[technologies][filters][$or][0][molecule_only][$eq]",
      "false"
    );
    url.searchParams.set(
      "populate[technologies][filters][$or][1][molecule_only][$null]",
      "true"
    );

    fetch(url.href, {method: "GET", headers})
      .then((response) => response.json())
      .then((data) => {
        setClusterData(data);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrl, apiKey, clusterId]);

  return {clusterData, error};
};

export default useFetchDataTechClusterById;
